import React from 'react';
import { string, shape, arrayOf, func } from 'prop-types';

import { makeParagraph } from 'utils';

const SubcategoryBanner = ({
    filterId,
    title,
    text,
    image,
    subcategories,
    onChange
}) => {
    if (!subcategories || !subcategories.length) {
        return null;
    }

    return (
        <div className="listing-subcategory-banner">
            <div className="listing-subcategory-banner__image-wrapper">
                <picture>
                    <source media="(min-width: 1200px)" srcSet={image.url} />
                    <img
                        className="listing-subcategory-banner__image"
                        loading="lazy"
                        src={image.mobileUrl}
                        alt={image.alt}
                    />
                </picture>
            </div>

            <div className="listing-subcategory-banner__content">
                {title && (
                    <h3 className="listing-subcategory-banner__title">
                        {title}
                    </h3>
                )}
                {text && (
                    <div
                        className="listing-subcategory-banner__text"
                        dangerouslySetInnerHTML={{
                            __html: makeParagraph(text)
                        }}
                    />
                )}
                <div className="listing-subcategory-banner__subcategories">
                    {subcategories.map(({ id, value, checked, label }) => (
                        <div
                            className="listing-subcategory-banner__subcategory"
                            key={id}
                        >
                            <input
                                checked={checked}
                                id={id.toString()}
                                name={id}
                                onChange={() => onChange(id, filterId)}
                                type="checkbox"
                                value={value}
                            />
                            <label
                                htmlFor={id.toString()}
                                className="listing-subcategory-banner__subcategory-label"
                                dangerouslySetInnerHTML={{
                                    __html: label.toString()
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

SubcategoryBanner.propTypes = {
    filterId: string,
    title: string.isRequired,
    text: string.isRequired,
    image: shape({
        url: string,
        mobileUrl: string,
        alt: string
    }),
    subcategories: arrayOf(shape({})).isRequired,
    onChange: func.isRequired
};

export default SubcategoryBanner;
